// Tipo di provvedimento (regole dello studio del 27/10, come finanziario.TIPI_PROVVEDIMENTO nel
// backend e il CHECK della migrazione 028). "Ordinanza" generica resta per i dati esistenti: nel
// form si propone solo se è già il valore salvato. Scadenze di giudicato e ottemperanza si calcolano
// solo per la Sentenza (quelle già salvate si mostrano come sono); con una Sentenza o un Dispositivo
// con numero il giudizio è deciso, altrimenti una scheda depositata è "Pendente" (stessa regola del
// filtro "in attesa di sentenza", finanziario.SQL_SCHEDE_DECISE).
export const TIPI_PROVVEDIMENTO = ['Sentenza', 'Dispositivo', 'Ordinanza cautelare', 'Ordinanza', 'Decreto', 'Altro'];
export const TIPI_DECISIONE = ['Sentenza', 'Dispositivo'];
export const ETICHETTE_BREVI = {
  Sentenza: 'Sent.', Dispositivo: 'Disp.', 'Ordinanza cautelare': 'Ord. caut.', Ordinanza: 'Ord.', Decreto: 'Decr.', Altro: 'Provv.',
};

export const tipoProvvedimento = (r) => r?.tipo_provvedimento || 'Sentenza';
export const etichettaProvvedimento = (r) => ETICHETTE_BREVI[tipoProvvedimento(r)] || 'Provv.';
export const conScadenze = (tipo) => (tipo || 'Sentenza') === 'Sentenza';

// tipi del form: i nuovi inserimenti non hanno "Ordinanza" generica, a meno che sia il valore salvato
export const tipiSelezionabili = (salvato) => TIPI_PROVVEDIMENTO.filter(t => t !== 'Ordinanza' || salvato === 'Ordinanza');

export const giudizioDeciso = (r) => TIPI_DECISIONE.includes(tipoProvvedimento(r)) && !!String(r?.numero_sentenza || '').trim();
export const giudizioPendente = (r) => r?.stato === 'depositato' && !giudizioDeciso(r);

// udienza o rinvio da oggi in poi (la card la mostra anche quando c'è un provvedimento)
export function udienzaFutura(data, oggi = new Date()) {
  if (!data || data === 'None') return false;
  const g = `${oggi.getFullYear()}-${String(oggi.getMonth() + 1).padStart(2, '0')}-${String(oggi.getDate()).padStart(2, '0')}`;
  return String(data).substring(0, 10) >= g;
}
